<template>
    <div>
        <el-select v-model="queryParams.status">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="已读" :value="1"></el-option>
            <el-option label="未读" :value="0"></el-option>
        </el-select>
        <el-input placeholder="请输入标题" v-model="queryParams.newsTitle" style="width: 350px"></el-input>
        <el-button type="primary" @click="searchData">查询</el-button>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="id" label="ID" width="150px"></el-table-column>
            <el-table-column prop="newsTitle" label="标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="pureText" label="简介" show-overflow-tooltip></el-table-column>
            <el-table-column prop="referLink" label="来源链接">
                <template slot-scope="scope">
                    <a :href="scope.row.referLink" target="_blank" @click="readClick(scope.row.id)">{{scope.row.referLink}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="sourceType" label="来源" show-overflow-tooltip width="200px"></el-table-column>
            <el-table-column prop="status" label="状态" width="100px">
                <template slot-scope="scope">
                    <span v-if="scope.row.status==0" style="color: red">未读</span>
                    <span v-if="scope.row.status==1" style="color: #00e200">已读</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="200px">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="100px">
                <template slot-scope="scope">
                    <el-button type="danger" @click="handleRemove(scope.row.id)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import '../store';
    import api from './api';

    export default {
        name: 'Message',
        data() {
            return {
                dataList: [], //栏目列表
                total: 0, //总条数
                queryParams: { //查询参数
                    newsTitle: "",
                    status: 0,
                    page: 1,
                    size: 10
                }
            };
        },
        methods: {
            searchData() {
                this.queryParams.page = 1;
                this.getMessageList();
            },
            getMessageList() {
                api.getMessageList(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            handleRemove(id) {
                this.$confirm('确认删除吗？删除后不可恢复', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteMessageByIds({"ids": id}).then(({data}) => {
                        this.$message.success('删除成功！');
                        this.getMessageList();
                    });
                }).catch(() => {
                });
            },
            readClick(id) {
                api.readMessageById({"id": id}).then(({data}) => {
                    this.getMessageList();
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getMessageList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getMessageList();
            }
        },
        created() {
            this.getMessageList();
        }
    };
</script>

<style lang="less" scoped></style>